import ModalityAvatar from './ModalityAvatar';

export default ModalityAvatar;
